module.exports = __webpack_public_path__ + "img/morkbanner.a3485802.png";